const doc = [({"ja":({"adminButtonHotel":({"backToHotelShow":"ホテル情報へ戻る", "changeChannelManager":"サイトコントローラーを変更する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;